module.exports = __webpack_public_path__ + "static/media/004.ba46cc7d.jpg";